import React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
import RoleGate from 'components/RoleGate';
import RoleButtonLink from 'components/RoleButtonLink';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import TableActions from 'components/TableActions';
import TimesheetIsApprovedGate from 'components/TimesheetIsApprovedGate';
import TimesheetIsUnapprovedGate from 'components/TimesheetIsUnapprovedGate';

// Child Components
import TimesheetApprovedByUserNameValue from './components/TimesheetApprovedByUserNameValue';
import TimesheetApproveLink from './components/TimesheetApproveLink';
// @ts-ignore
import TimesheetComment from './components/TimesheetComment';
import TimesheetDeleteLink from './components/TimesheetDeleteLink';
// @ts-ignore
import TimesheetEntityName from './components/TimesheetEntityName';
// @ts-ignore
import TimesheetGroupName from './components/TimesheetGroupName';
import TimesheetIsApproved from './components/TimesheetIsApproved';
import TimesheetIsNotExportedGate from './components/TimesheetIsNotExportedGate';
import TimesheetLastExportedAt from './components/TimesheetLastExportedAt';
import TimesheetPersonFirstNameValue from './components/TimesheetPersonFirstNameValue';
import TimesheetPersonLastNameValue from './components/TimesheetPersonLastNameValue';
import TimesheetTableRowLink from './components/TimesheetTableRowLink';
// @ts-ignore
import TimesheetWorkTypeName from './components/TimesheetWorkTypeName';
import TimesheetCheckbox from '../../../TimesheetCheckbox';
import TimesheetUnapproveLink from './components/TimesheetUnapproveLink';
import TimesheetTotalTime from './components/TimesheetTotalTime';
import TimesheetSubmissionReference from './components/TimesheetSubmissionReference';

interface Props {
    timesheetId?: number;
}

export default class TimesheetsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { timesheetId } = this.props;
        if (!timesheetId) {
            return null;
        }
        return (
            <TimesheetTableRowLink
                timesheetId={timesheetId}
                namespace={`TimesheetTimesheetEntriesForm.${timesheetId}`}
            >
                <Table.Cell className="checkbox">
                    <TimesheetCheckbox rowId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetPersonFirstNameValue timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetPersonLastNameValue timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetGroupName timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetWorkTypeName timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetEntityName timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetComment timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetTotalTime timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetIsApproved timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetApprovedByUserNameValue
                        timesheetId={timesheetId}
                    />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetLastExportedAt timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell>
                    <TimesheetSubmissionReference timesheetId={timesheetId} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <TimesheetIsUnapprovedGate timesheetId={timesheetId}>
                            <RoleGate
                                requiredRoles={[
                                    ADMIN,
                                    MANAGER,
                                    ASSISTANT_MANAGER
                                ]}
                            >
                                <TimesheetDeleteLink
                                    timesheetId={timesheetId}
                                />
                            </RoleGate>
                            <RoleGate requiredRoles={[ADMIN, MANAGER]}>
                                <TimesheetApproveLink
                                    timesheetId={timesheetId}
                                />
                            </RoleGate>
                        </TimesheetIsUnapprovedGate>
                        <TimesheetIsApprovedGate timesheetId={timesheetId}>
                            <TimesheetIsNotExportedGate
                                timesheetId={timesheetId}
                            >
                                <React.Fragment>
                                    <RoleGate requiredRoles={[ADMIN, MANAGER]}>
                                        <TimesheetUnapproveLink
                                            timesheetId={timesheetId}
                                        />
                                    </RoleGate>
                                    <RoleButtonLink
                                        requiredRoles={[ADMIN, MANAGER]}
                                        params={{
                                            selectedTimesheet: timesheetId,
                                            timesheetSubmitModal: true
                                        }}
                                    >
                                        Submit
                                    </RoleButtonLink>
                                </React.Fragment>
                            </TimesheetIsNotExportedGate>
                        </TimesheetIsApprovedGate>
                    </TableActions>
                </Table.Cell>
            </TimesheetTableRowLink>
        );
    }
}
